import signedFetch from '../util/signedFetch.js';

export default (orgId, userId) =>
  signedFetch('orbGetUserPreferences', `${__API_BASE__}/org/${orgId}/user/${userId}/orb/preferences`);
